var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "building-side" },
    [
      !!_vm.selectedFloorbox.uuid
        ? _c(
            "v-btn",
            {
              staticClass: "group-button",
              attrs: { "x-small": "", plain: "", elevation: "0" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.$emit("click")
                }
              }
            },
            [
              _c("v-icon", { staticStyle: { "font-size": "24px" } }, [
                _vm._v("mdi-select-group")
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isBuildingEntranceFloor && !_vm.selectedFloorbox.uuid
        ? _c("div", { staticClass: "door" })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2811964a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2811964a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Buildings/Vertical/BuildingComponents/Side.vue
// module id = null
// module chunks = 